(function() { module.exports = window["Bernie_l10nBundle_ro_RO"]; }());